export const WHITE_LIST_ENDPOINT = 'https://xvkvojl7o2.execute-api.us-east-1.amazonaws.com/prod';
export const QUEUE_ENDPOINT = 'https://6upov7c309.execute-api.us-east-1.amazonaws.com/prod';
export const MINTED_NFT_ENDPOINT = 'https://37i9cpuqx0.execute-api.us-east-1.amazonaws.com/prod';
export const PURCHASE_API = 'https://2xnvhkrjoi.execute-api.us-east-1.amazonaws.com/prod';
export const MARKET_NFT_API = 'https://7l5tdhtuqa.execute-api.us-east-1.amazonaws.com/prod';
export const FLOW_UNPACKER_API = 'https://5poc6vf564.execute-api.us-east-1.amazonaws.com/prod';
